import {
  CreateItemCacheKeys,
  CreateItemGqlQuery,
  CreatedAt,
  DateFilterType,
  DeleteItemCacheKeys,
  DeleteItemGqlQuery,
  FetchItemCacheKey,
  FetchItemGqlQuery,
  FetchItemsCacheKey,
  FetchItemsGqlQuery,
  FetchItemsLimit,
  FetchItemsPage,
  FetchItemsSort,
  ID,
  IdFilterType,
  NanoID,
  TextFilterType,
  UUID,
  UpdateItemCacheKeys,
  UpdateItemGqlQuery,
  UpdatedAt
} from '../../types';
import { UserID, UserNanoID } from '../users/usersTypes';

export type GlobalCompanyTabID = ID;
export type GlobalCompanyTabUUID = UUID;
export type GlobalCompanyTabNanoID = NanoID;
export type GlobalCompanyTabName = string;
export type GlobalCompanyTabContent = string;
export type GlobalCompanyTabPosition = number;
export type GlobalCompanyTabType = string;
export type GlobalCompanyTabCompanyType = string;
export type GlobalCompanyTabCreatedAt = CreatedAt;
export type GlobalCompanyTabUpdatedAt = UpdatedAt;
export type GlobalCompanyTabUserID = UserID;

export interface GlobalCompanyTabUser {
  id: UserID;
  nanoId: UserNanoID;
}

export type GlobalCompanyTabRoleUID = ID;

export interface GlobalCompanyTabRole {
  id: ID;
  uuid: UUID;
  nanoId: NanoID;
  name: string;
}

export const enum FetchGlobalCompanyTabsSortTypes {
  ID_ASC = 'ID_ASC',
  ID_DESC = 'ID_DESC',
  UUID_ASC = 'UUID_ASC',
  UUID_DESC = 'UUID_DESC',
  CREATED_AT_ASC = 'CREATED_AT_ASC',
  CREATED_AT_DESC = 'CREATED_AT_DESC',
  UPDATED_AT_ASC = 'UPDATED_AT_ASC',
  UPDATED_AT_DESC = 'UPDATED_AT_DESC',
  DELETED_AT_ASC = 'DELETED_AT_ASC',
  DELETED_AT_DESC = 'DELETED_AT_DESC',
  NAME_ASC = 'NAME_ASC',
  NAME_DESC = 'NAME_DESC',
  COMPANY_TYPE_ASC = 'COMPANY_TYPE_ASC',
  COMPANY_TYPE_DESC = 'COMPANY_TYPE_DESC',
  POSITION_ASC = 'POSITION_ASC',
  POSITION_DESC = 'POSITION_DESC'
}

export interface FetchGlobalCompanyTabsFilters {
  id?: IdFilterType;
  createdAt?: DateFilterType;
  updatedAt?: DateFilterType;
  name?: TextFilterType;
  companyType?: TextFilterType;
}

export type FetchGlobalCompanyTabsGqlQuery = FetchItemsGqlQuery;
export type FetchGlobalCompanyTabsCacheKey = FetchItemsCacheKey;
export type FetchGlobalCompanyTabsSort = FetchItemsSort;
export type FetchGlobalCompanyTabsPage = FetchItemsPage;
export type FetchGlobalCompanyTabsLimit = FetchItemsLimit;

export type FetchGlobalCompanyTabGqlQuery = FetchItemGqlQuery;
export type FetchGlobalCompanyTabCacheKey = FetchItemCacheKey;

export type CreateGlobalCompanyTabGqlQuery = CreateItemGqlQuery;
export type CreateGlobalCompanyTabCacheKeys = CreateItemCacheKeys;

export type UpdateGlobalCompanyTabGqlQuery = UpdateItemGqlQuery;
export type UpdateGlobalCompanyTabCacheKeys = UpdateItemCacheKeys;

export type DeleteGlobalCompanyTabGqlQuery = DeleteItemGqlQuery;
export type DeleteGlobalCompanyTabCacheKeys = DeleteItemCacheKeys;
